import React, {useRef} from 'react';
import Paper from '@material-ui/core/Card';
import {useHistory} from "react-router";

import CampaignDetailsForm from './form';
import Loading from "../../_common/loading";
import LargeAppBar from "../../_common/largeAppBar";
import {campaignSelector, campaignSavingSelector} from "../../../redux/campaigns/selectors";

import './index.css';
import {useSelector} from "react-redux";

const CampaignDetails = ({ campaignId }) => {
    const campaignSaving = useSelector(campaignSavingSelector);
    const campaign = useSelector(campaignSelector(campaignId));
    const history = useHistory();
    const submitRef = useRef(null);

    const goBack = () => history.push('/campaigns');

    return (
        <div>
            {!campaign ?
                <Loading size={45} />
                :
                <>
                    <LargeAppBar
                        loading={campaignSaving}
                        title={campaign.id ? "Edit Campaign" : "Add Campaign"}
                        onSaveClick={() => submitRef.current.click()}
                        onBackClick={goBack}
                        onCancelClick={goBack} />
                    <div className="flex justify-content-center">
                        <Paper className="campaign-details-card" square elevation={4}>
                            <CampaignDetailsForm campaign={campaign} submitRef={submitRef} saving={campaignSaving} goBack={goBack} />
                        </Paper>
                    </div>
                </>
            }
        </div>
    )
};

export default CampaignDetails;